import { pb } from './pocketbase';

export const getCompanyMemos = async (companyId) => {
    try {
        // Configuration simple sans options d'annulation
        const records = await pb.collection('company_memos').getList(1, 50, {
            filter: `company_id="${companyId}"`,
            sort: '-created',
            expand: 'created_by'
        });
        return records.items;
    } catch (error) {
        // Ne pas afficher d'erreur si c'est juste qu'il n'y a pas de mémos (404)
        if (error.status === 404) {
            return [];
        }
        console.error(`Erreur lors de la récupération des mémos de l'entreprise ${companyId}:`, error);
        throw error;
    }
};

export const createCompanyMemo = async (memoData) => {
    try {

        if (pb.authStore.isValid && pb.authStore.model) {
            const memoWithPartnerId = {
                ...memoData,
                partner_id: pb.authStore.record.partner_id
            };
            const createdMemo = await pb.collection('company_memos').create(memoWithPartnerId);
            return createdMemo;
        } else {
            console.error('Aucun utilisateur authentifié. Impossible de créer le mémo sans partner_id.');
            return null;
        }
    } catch (error) {
        console.error('Erreur lors de la création du mémo:', error);
        throw error;
    }
};

